import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Country } from "../Types/countryTypes";

export const countriesApi = createGenericApiSlice<Country>({
	reducerPath: "countriesApi",
	tag: TagTypes.Country,
	endpoint: "countries",
});

export const {
	useGetAllQuery: useGetCountriesQuery,
	useGetByIdQuery: useGetCountryByIdQuery,
	useCreateMutation: useCreateCountryMutation,
	useUpdateMutation: useUpdateCountryMutation,
	useDeleteMutation: useDeleteCountryMutation,
} = countriesApi;
